import * as i0 from '@angular/core';
import { Injectable, Component, Inject, EventEmitter, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, delay, distinctUntilChanged } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import * as i3 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i4 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i7 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { EIPAutoCompleteModule } from 'eipauto-complete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

class EIPGeneralCartService {
    constructor(http) {
        this.http = http;
    }
    // httpPostCallWithHeader(WebApiURL: string, requestBody: any, requestHeaders: any): Observable<any> {
    httpPostCallWithHeader(WebApiURL, requestBody) {
        var body = requestBody;
        // if (_isHeaderAvailable)
        // body['headers'] = requestHeaders
        return this.http.post(WebApiURL, body, { headers: requestBody['headers'] });
    }
    getCardItemsByID(WebApiURL, requestBody) {
        var body = requestBody;
        return this.http.post(WebApiURL, body, { headers: requestBody['headers'] });
    }
}
EIPGeneralCartService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
EIPGeneralCartService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class JobRequestModel {
}

class CartRequest {
    constructor() {
        this["param"] = [];
    }
}
class requestParam {
}

class CartHelper {
    constructor() {
        this.originalCartCollection = [];
    }
    getMaterialGroupApi() {
        let _matGroupApi = '';
        return _matGroupApi;
    }
    getCartIndex(_value, _collection) {
        let _index = -1;
        if (_collection.length > 0) {
            _index = _collection.findIndex(element => {
                return (element['value'] === _value);
            });
        }
        return _index;
    }
    getSelectedItem(_selectedCartItem, _originalCollection) {
        let _selectedItem = {};
        const _value = _selectedCartItem.option._value;
        _selectedItem = {
            value: _value,
            text: this.getSelectedCartText(_value, _originalCollection)
            // _selectedCartItem.option._element.nativeElement.dataset['text'].trim()
        };
        return _selectedItem;
    }
    getSelectedCartText(_value, _originalCollection) {
        let _selectedCartItemText = '';
        let _index = -1;
        if (_originalCollection && _originalCollection.length > 0) {
            _index = _originalCollection.findIndex(element => {
                return (element['value'] === _value);
            });
            if (_index > -1) {
                _selectedCartItemText = _originalCollection[_index]['text'];
            }
        }
        return _selectedCartItemText;
    }
    getOriginalCartCollection() {
        return this.originalCartCollection;
    }
    setCartCollection(_emittingList, _valueField, _textField) {
        let _index = -1;
        let _collection = [];
        this.originalCartCollection = [];
        _collection = _emittingList.map((n) => ({
            value: n[_valueField],
            text: n[_textField],
            additionalValues: n
        }));
        if (_textField === '') {
            _collection.filter(n => {
                _index = -1;
                _index = this.getMatchingIndex(this.originalCartCollection, n['value'], n['text']);
                if (_index === -1) {
                    this.originalCartCollection.push({
                        value: n['value'],
                        text: n['value'],
                        additionalValues: n['additionalValues']
                    });
                }
            });
        }
        else {
            _collection.filter(n => {
                _index = -1;
                _index = this.getMatchingIndex(this.originalCartCollection, n['value'], n['text']);
                if (_index === -1) {
                    this.originalCartCollection.push({
                        value: n['value'],
                        text: n['value'] + ' - ' + n['text'],
                        additionalValues: n['additionalValues']
                    });
                }
            });
        }
    }
    getFilteredCartItems(_collection, _searchValue, minLimit, maxLimit, _condition) {
        let _outCollection = [];
        if (!minLimit) {
            minLimit = 0;
        }
        if (!maxLimit) {
            maxLimit = 100;
        }
        if (!_condition) {
            _outCollection =
                _collection.filter(option => option.text.toLowerCase().includes(_searchValue.toString().toLowerCase().trim()))
                    .slice(minLimit, maxLimit);
        }
        else if (_condition === 'all') {
            _outCollection =
                _collection.filter(option => option.text.toLowerCase().includes(_searchValue.toString().toLowerCase().trim()));
        }
        return _outCollection;
    }
    // getFilteredCartItems(_collection: any[], _searchValue): any[] {
    //     let _outCollection: any[] = []
    //     _outCollection =
    //         _collection.filter(option =>
    //             option.text.toLowerCase().includes(_searchValue.toLowerCase().trim()))
    //     return _outCollection
    // }
    getMatchingIndex(_collection, _value, text) {
        let _index = -1;
        _index = _collection.findIndex(cartElement => {
            return cartElement['value'] === _value && cartElement['text'] === text;
        });
        return _index;
    }
    isRecordAvailable(_value, _text, _collection) {
        let _isRecordAvailable = false;
        let _index = -1;
        if (_collection.length > 0) {
            _index = this.getMatchingIndex(_collection, _value, _text);
            if (_index > -1) {
                _isRecordAvailable = true;
            }
        }
        return _isRecordAvailable;
    }
    getUniqueItems(_rightCollection) {
        let _index = -1;
        let _collection = [];
        if (_rightCollection && _rightCollection.length > 0) {
            if (this.originalCartCollection && this.originalCartCollection.length > 0) {
                this.originalCartCollection.filter(element => {
                    _index = -1;
                    _index = _rightCollection.findIndex(_rightItems => {
                        return _rightItems['value'] === element['value'];
                    });
                    if (_index === -1) {
                        _collection.push(element);
                    }
                });
            }
        }
        return _collection;
    }
    getJobCartRequestPayload(_cartParams) {
        let _jobRequest = new JobRequestModel();
        if (_cartParams) {
            _jobRequest.userId = _cartParams['UID'];
            _jobRequest.dtCode = _cartParams['dtCode'];
            _jobRequest.doptCode = _cartParams['doptCode'];
            _jobRequest.searchText = '';
        }
        return _jobRequest;
    }
    removeSelectedItems(_collection, _removingList) {
        let index = -1;
        _removingList.filter(element => {
            index = -1;
            index = this.getMatchingIndex(_collection, element['value'], element['text']);
            if (index > -1) {
                _collection.splice(index, 1);
            }
        });
        return _collection;
    }
    getCartRequestPayload(_emittingList, _companyCode, _categoryCode, _UID) {
        let _cartRequest = new CartRequest();
        let _index = -1;
        let _prevIndex = -1;
        let _uniqueList = [];
        _emittingList.filter(filterelement => {
            _index = _emittingList.findIndex(element => {
                return element['value'].toLowerCase().trim() === filterelement['value'].toLowerCase().trim();
            });
            // on incremental search
            if (_index > -1 && _prevIndex < _index) {
                _prevIndex = _index;
                _uniqueList.push(_emittingList[_index]['value']);
            }
        });
        if (_emittingList && _emittingList.length > 0) {
            _cartRequest.UID = _UID;
            _cartRequest.masterType = 'SelMaterialCategory';
            _cartRequest.param.push({
                key: 'intCompanyCode',
                value: _companyCode
            });
            _cartRequest.param.push({
                key: 'strTrantype', value: 'GetMatCategoryGrpBulk'
            });
            _cartRequest.param.push({
                key: 'strCategoryCode', value: _categoryCode
            });
            _cartRequest.param.push({
                key: 'jsonGroupCodes',
                value: this.getGroupCodeParams(_uniqueList)
            });
        }
        return _cartRequest;
    }
    getGroupCodeParams(_uniqueList) {
        let _groupCodeParams = '';
        let _index = -1;
        // _groupCodeParams = '[{\\"strGroupCode\\" :\\"3o51\\"}, {\\"strGroupCode\\": \\"771384\\"}]'
        _groupCodeParams = '[';
        _uniqueList.forEach(element => {
            _index++;
            _groupCodeParams += '{\"strGroupCode\" :\"' + element + '"\}';
            if (_index < _uniqueList.length - 1) {
                _groupCodeParams += ',';
            }
        });
        _groupCodeParams += ']';
        return _groupCodeParams;
    }
}

class MessageboxComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.alertMessage = data['_message'];
    }
    ngOnInit() {
    }
    closeDialog() {
        this.dialogRef.close();
    }
}
MessageboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MessageboxComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
MessageboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: MessageboxComponent, selector: "lib-messagebox", ngImport: i0, template: "<table style=\"width:300px; height: 150px; text-align: center\">\r\n    <tr>\r\n        <td>\r\n            {{alertMessage}}\r\n        </td>\r\n    </tr>\r\n    <tr style=\"height:25px\"></tr>\r\n    <tr>\r\n\r\n        <td>\r\n            <button (click)=\"closeDialog()\">OK</button>\r\n        </td>\r\n    </tr>\r\n</table>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MessageboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-messagebox', template: "<table style=\"width:300px; height: 150px; text-align: center\">\r\n    <tr>\r\n        <td>\r\n            {{alertMessage}}\r\n        </td>\r\n    </tr>\r\n    <tr style=\"height:25px\"></tr>\r\n    <tr>\r\n\r\n        <td>\r\n            <button (click)=\"closeDialog()\">OK</button>\r\n        </td>\r\n    </tr>\r\n</table>", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    } });

class DialogBoxHelper {
    showAlert(_message, _dialog) {
        if (_dialog.open) {
            const dialogRef = _dialog.open(MessageboxComponent, {
                data: { _message }
            });
            dialogRef.afterClosed().subscribe(result => {
            });
        }
    }
}

class selectArrowModel {
    constructor() {
        //     isSelectDisabled: boolean = false
        //     isSelectAllDisabled: boolean = false
        //     isUnSelectDisabled: boolean = false
        //     isUnSelectAllDisabled: boolean = false
        this.isLeftDisabled = true;
        this.isLeftAllDisabled = true;
        this.isRightDisabled = true;
        this.isRightAllDisabled = true;
    }
}

// import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
class EIPGeneralCartComponent {
    constructor(environmentvalue, eipCartService, dialog) {
        this.eipCartService = eipCartService;
        this.dialog = dialog;
        this.generalcartParams = {};
        this.CartParameters = {};
        this.postButtonText = 'Post';
        this.SearchLength = 0;
        this.excelUploadAPIParams = {};
        this.excelUploadWithAPICall = false;
        this.OnCartClose = new EventEmitter();
        this.OnCartSubmit = new EventEmitter();
        this.cartParams = {};
        this.matGroupApi = '';
        this.matGroupParams = {};
        this.companyCode = '';
        this.categoryCode = '';
        this.Showloader = false;
        this.isLoaderRequired = 'Y';
        this.categoryText = '';
        this.UID = '';
        this._headers = {};
        this.cartCollection = [];
        this.cartSelectedCollection = [];
        this.cartTempCollection = [];
        this.selectedOptions = '';
        this.cartHelper = new CartHelper();
        this._leftTempCollection = [];
        this._rightTempCollection = [];
        this.leftSearchValue = '';
        this.leftSearchValueChange = new EventEmitter();
        this.rightSearchValue = '';
        this.emittingList = [];
        this.isCloseCirecleRequired = 'Y';
        this.cartType = '';
        this.cartText = '';
        this.cartRightText = 'Selected Items';
        this.environmentAPIUrl = '';
        this._matGroupDefaultValues = [];
        this._selectArrowModel = new selectArrowModel();
        this.dataSource = [];
        this.isNoRecordsInRight = false;
        this.isNoRecordsInLeft = false;
        this.totalItemCount = 0;
        this.totalItemCountList = 0;
        this.totalSelectedItemCount = 0;
        this.totalCountDisplay = 'N';
        this.excelProperty = '';
        this.minimumSelectedItemCount = 1;
        this.maximumSelectedItemCount = -1;
        this.isNoRecords = false;
        this.environmentAPIUrl = environmentvalue.baseUrl;
    }
    ngOnInit() {
        let _cartParams = {};
        if (this.SearchLength.toString().trim() === '0') {
            this.placeHolderContent = 'Search...';
        }
        else {
            this.placeHolderContent = 'enter min of ' + this.SearchLength + ' char and press tab to search';
        }
        if (this.cartParams['settings']) {
            if (this.cartParams['settings']['totalCountDisplay']) {
                this.totalCountDisplay = this.cartParams['settings']['totalCountDisplay'];
            }
            this.excelProperty = this.cartParams.settings.hasOwnProperty('excelProperty') ? this.cartParams.settings.excelProperty : '';
            if (this.cartParams['settings'].hasOwnProperty('minimumSelectedItemCount')) {
                let minCount = Number(this.cartParams['settings']['minimumSelectedItemCount']);
                this.minimumSelectedItemCount = (typeof minCount === 'number') ? minCount : 1;
            }
            else {
                this.minimumSelectedItemCount = 1;
            }
            if (this.cartParams['settings'].hasOwnProperty('maximumSelectedItemCount')) {
                let maxCount = Number(this.cartParams['settings']['maximumSelectedItemCount']);
                this.maximumSelectedItemCount = (typeof maxCount === 'number') ? maxCount : -1;
            }
            else {
                this.maximumSelectedItemCount = -1;
            }
        }
    }
    ngOnChanges() {
        if (this.CartParameters) {
            if (this.CartParameters['settings']['isCloseCirecleRequired']) {
                if (this.CartParameters['settings']['isCloseCirecleRequired'] === 'N') {
                    this.isCloseCirecleRequired = 'N';
                }
            }
            if (this.CartParameters['settings']['isLoaderRequired']) {
                this.isLoaderRequired = this.CartParameters['settings']['isLoaderRequired'];
            }
            if (this.cartParams['settings'] && this.cartParams['settings']['totalCountDisplay']) {
                this.totalCountDisplay = this.cartParams['settings']['totalCountDisplay'];
            }
            if (this.cartParams['settings']) {
                if (this.cartParams['settings'].hasOwnProperty('minimumSelectedItemCount')) {
                    let minCount = Number(this.cartParams['settings']['minimumSelectedItemCount']);
                    this.minimumSelectedItemCount = (typeof minCount === 'number') ? minCount : 1;
                }
                else {
                    this.minimumSelectedItemCount = 1;
                }
                if (this.cartParams['settings'].hasOwnProperty('maximumSelectedItemCount')) {
                    let maxCount = Number(this.cartParams['settings']['maximumSelectedItemCount']);
                    this.maximumSelectedItemCount = (typeof maxCount === 'number') ? maxCount : -1;
                }
                else {
                    this.maximumSelectedItemCount = -1;
                }
            }
            if (this.SearchLength.toString().trim() === '0') {
                let _isDataSourceAvailable = false;
                if (JSON.stringify(this.CartParameters) !== '{}') {
                    if (this.CartParameters['WebapiURL']) {
                        this.cartParams = this.CartParameters;
                        this.loadCartParams();
                    }
                    else if (this.CartParameters['dataSource']) {
                        _isDataSourceAvailable = true;
                        this.dataSource = this.CartParameters['dataSource'];
                        this.cartParams = this.CartParameters;
                        this.cartText = this.cartParams['settings']['cartLabel'];
                        if (this.cartParams['settings']['cartRightLabel']) {
                            this.cartRightText = this.cartParams['settings']['cartRightLabel'];
                        }
                        else {
                            this.cartRightText = 'Selected Items';
                        }
                        if (this.cartParams['settings']['isLoaderRequired']) {
                            this.isLoaderRequired = this.cartParams['settings']['isLoaderRequired'];
                        }
                        this.setDefaultCartItems();
                        this.setCartCollection(null, this.CartParameters['settings']);
                    }
                    // else if (this.CartParameters['dataSource']) {
                    //   _isDataSourceAvailable = true;
                    //   this.dataSource = this.CartParameters['dataSource'];
                    //   this.setCartCollection(null, this.CartParameters['settings']);
                    //   this.cartParams = this.CartParameters;
                    //   this.setDefaultCartItems();
                    // }
                }
            }
            else {
                this.cartParams = this.CartParameters;
                this.cartText = this.cartParams['settings']['cartLabel'];
                if (this.cartParams['settings']['cartRightLabel']) {
                    this.cartRightText = this.cartParams['settings']['cartRightLabel'];
                }
                else {
                    this.cartRightText = 'Selected Items';
                }
                this.setDefaultCartItems();
            }
            // let _isDataSourceAvailable = false;
            // if (JSON.stringify(this.CartParameters) !== '{}') {
            //   if (this.CartParameters['WebapiURL']) {
            //     this.cartParams = this.CartParameters;
            //     this.loadCartParams();
            //   } else if (this.CartParameters['dataSource']) {
            //     _isDataSourceAvailable = true;
            //     this.dataSource = this.CartParameters['dataSource'];
            //     this.setCartCollection(null, this.CartParameters['settings']);
            //     this.cartParams = this.CartParameters;
            //     this.setDefaultCartItems();
            //   }
            // }
        }
    }
    // Excel upload and get properties and data
    onFileChange(event) {
        /* wire up file reader */
        const target = (event.target);
        if (target.files.length !== 1) {
            throw new Error('Cannot use multiple files');
        }
        const reader = new FileReader();
        reader.readAsBinaryString(target.files[0]);
        reader.onload = (e) => {
            /* create workbook */
            const binarystr = e.target.result;
            const wb = XLSX.read(binarystr, { type: 'binary' });
            /* selected the first sheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* save data */
            const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
            //console.log(data); // Data will be logged in array format containing objects
            if (this.uploadFile)
                this.uploadFile.nativeElement.value = '';
            if (!this.excelUploadWithAPICall)
                this.transferExcelMatchingData(data);
            else {
                if (this.excelUploadAPIParams) {
                    const APIURL = this.CartParameters['WebapiURL'].URL;
                    const { listItemKey, objectKey } = this.excelUploadAPIParams;
                    const listItemValues = data.map(objectValue => ({
                        [objectKey]: objectValue[this.excelProperty].trim()
                    }));
                    // console.log(listItemValues);
                    const reqBody = this.excelUploadAPIParams;
                    delete reqBody.listItemKey;
                    delete reqBody.objectKey;
                    this.eipCartService.getCardItemsByID(APIURL, Object.assign(Object.assign({}, reqBody), { [listItemKey]: listItemValues })).subscribe(res => {
                        this.cartCollection = res ? res : [];
                        this.loadGeneralCart(this.cartCollection, this.CartParameters['settings']);
                        this.cartCollection = this._leftTempCollection;
                        if (this.cartCollection)
                            this.transferExcelMatchingData(data);
                    });
                }
            }
        };
    }
    transferExcelMatchingData(data) {
        const matchedData = [];
        if (data && data.length > 0) {
            data.forEach(item => {
                const index = this.cartCollection.findIndex(x => x.value.trim() === item[this.excelProperty].trim());
                if (index !== -1) {
                    matchedData.push(this.cartCollection[index]);
                }
            });
            // console.log(matchedData);
            this.cartMoveSelectedItems(matchedData);
        }
    }
    setDefaultCartItems() {
        if (this.cartParams['params']) {
            if (this.cartParams['params']['selectedCartItems']) {
                this._rightTempCollection = this.cartParams['params']['selectedCartItems'];
                this.cartSelectedCollection = this.cartParams['params']['selectedCartItems'];
                // if the right collection length>0 then enable right all arrow
                if (this._rightTempCollection.length > 0) {
                    this._selectArrowModel.isRightAllDisabled = false;
                    this.totalSelectedItemCount = this._rightTempCollection.length;
                    this.totalItemCount = this.totalItemCountList - this.totalSelectedItemCount;
                }
            }
        }
    }
    loadCart(_collection, _minLimit, _maxLimit, _searchText) {
        let _cartCollection = [];
        if (_searchText && _searchText.trim() !== '') {
            _cartCollection = this.cartHelper.getFilteredCartItems(_collection, _searchText, _minLimit, _maxLimit);
        }
        else {
            _cartCollection = _collection.slice(_minLimit, _maxLimit);
        }
        return _cartCollection;
    }
    loadCartParams() {
        if (this.cartParams && (JSON.stringify(this.cartParams) !== '{}')) {
            // this.UID = this.cartParams['params']['UID'];
            if (this.SearchLength.toString().trim() !== '0') {
                if (this.cartParams['params'].param) {
                    if (this.cartParams['settings']['apiSearchParam']) {
                        if (this.cartParams['params'].param.filter(n => n['key'] == this.cartParams['settings']['apiSearchParam']).length > 0) {
                            this.cartParams['params'].param.filter(n => n['key'] === this.cartParams['settings']['apiSearchParam'])[0]['value'] = this.leftSearchValue.trim();
                        }
                    }
                    else {
                        if (this.cartParams['params'].param.filter(n => n['key'] == this.cartParams['params']['SearchParam']).length > 0) {
                            this.cartParams['params'].param.filter(n => n['key'] === this.cartParams['params']['SearchParam'])[0]['value'] = this.leftSearchValue.trim();
                        }
                    }
                }
                else {
                    this.cartParams['params']['SearchParam'] = this.leftSearchValue.trim();
                    if (this.cartParams['settings']['apiSearchParam']) {
                        this.cartParams['params'][this.cartParams['settings']['apiSearchParam']] = this.leftSearchValue.trim();
                    }
                }
            }
            this.cartType = 'materialcart'; // this.cartParams['settings']['cartType']
            this._headers = this.cartParams['headers'];
            this.setDefaultCartItems();
            this.cartText = this.cartParams['settings']['cartLabel'];
            if (this.cartParams['settings']['cartRightLabel']) {
                this.cartRightText = this.cartParams['settings']['cartRightLabel'];
            }
            else {
                this.cartRightText = 'Selected Items';
            }
            // this.loadJobCart(this.cartParams['params'])
            this.setCartCollection(this.cartParams['params'], this.cartParams['settings']);
        }
    }
    setCartCollection(_emittingList, _settings) {
        let _requestParams = new CartRequest();
        let _textField;
        let _valueField;
        let _collection = [];
        let _webApi = '';
        if (this.cartParams['WebapiURL']) {
            _webApi = this.cartParams['WebapiURL']['URL']; // this.environmentAPIUrl + 'GLM/GLMCC/api/Masters'
            // _requestParams = this.cartHelper.getCartRequestPayload(this.emittingList, this.companyCode, this.categoryCode, this.UID)
            _requestParams = this.cartParams['params'];
            _requestParams['headers'] = this.cartParams['headers'];
            if (this.isLoaderRequired === 'Y') {
                this.Showloader = true;
            }
            const subscriber$ = this.eipCartService.httpPostCallWithHeader(_webApi, _requestParams)
                .pipe(debounceTime(500), delay(1000), 
            // throttleTime(1000),
            // tap(re => console.log(re)),
            distinctUntilChanged())
                .subscribe(result => {
                _collection = result || result['table'];
                if (_collection && _collection.length > 0) {
                    this.isNoRecordsInLeft = false;
                    this.isNoRecords = false;
                    this.loadGeneralCart(_collection, _settings);
                    if (this._leftTempCollection.length !== 0) {
                        this._selectArrowModel.isLeftAllDisabled = false;
                    }
                    this.cartCollection = this.loadCart(this._leftTempCollection, 0, 100);
                    this.totalItemCount = this._leftTempCollection.length;
                    this.totalItemCountList = this.totalItemCount;
                }
                else {
                    this._selectArrowModel.isLeftAllDisabled = true;
                    this._selectArrowModel.isRightAllDisabled = true;
                    this.isNoRecords = true;
                    this.isNoRecordsInLeft = true;
                    this._leftTempCollection = [];
                    this.cartCollection = [];
                    this.totalItemCount = this._leftTempCollection.length;
                    this.totalItemCountList = this.totalItemCount;
                }
                if (subscriber$) {
                    subscriber$.unsubscribe();
                }
                this.Showloader = false;
            }, (error) => {
                console.log(error, 'EIPCartAPI Error');
                this.Showloader = false;
                if (subscriber$) {
                    subscriber$.unsubscribe();
                }
            });
        }
        else if (this.dataSource.length > 0) {
            _collection = this.dataSource;
            this.loadGeneralCart(_collection, _settings);
            this.cartCollection = this.loadCart(this._leftTempCollection, 0, 100);
            this.totalItemCount = this._leftTempCollection.length;
            this.totalItemCountList = this.totalItemCount;
            this.handleSelectArrows();
        }
        else {
            this._selectArrowModel.isLeftAllDisabled = true;
            this._selectArrowModel.isRightAllDisabled = true;
            this.isNoRecords = true;
            this._leftTempCollection = [];
            this.cartCollection = [];
            this.totalItemCount = this._leftTempCollection.length;
            this.totalItemCountList = this.totalItemCount;
        }
    }
    loadGeneralCart(_collection, _settings) {
        let _textField;
        let _valueField;
        let _tmpLeftCollection = [];
        _valueField = _settings['valueField'];
        _textField = _settings['textField'];
        this.cartHelper.setCartCollection(_collection, _valueField, _textField);
        if (this._rightTempCollection.length > 0) {
            _tmpLeftCollection = this.cartHelper.getUniqueItems(this._rightTempCollection);
            this._leftTempCollection = _tmpLeftCollection;
        }
        else {
            this._leftTempCollection = this.cartHelper.getOriginalCartCollection();
        }
        // Enable select all in the left
        // this._selectArrowModel.isLeftAllDisabled = false
    }
    // setMaterialGroupValues(selectedMatGroup) {
    //   let _emittingList: any[] = []
    //   this.cartCollection = []
    //   this._leftTempCollection = []
    //   this.cartTempCollection = []
    //   if (selectedMatGroup && selectedMatGroup['emittingList']) {
    //     _emittingList = selectedMatGroup['emittingList']
    //     this.emittingList = _emittingList
    //     if (_emittingList.length > 0) {
    //       // this.cartHelper.setCartCollection(_emittingList)
    //       this.setCartCollection(_emittingList)
    //     }
    //   }
    // }
    // getCartItems(selectedItem, _location: string) {
    //   let _selectedItem: any = {}
    //   let _selectedCartItemText: string = ''
    //   let _collection: any[] = []
    //   const _selectedValue: string = selectedItem.option._value
    //   let _index: number = -1
    //   if (!this.isNoRecords) {
    //     if (_location == "left") {
    //       _collection = this.cartCollection
    //     }
    //     else if (_location == "right") {
    //       _collection = this.cartSelectedCollection
    //     }
    //     if (selectedItem.option._selected) {
    //       _selectedItem = this.cartHelper.getSelectedItem(selectedItem, _collection)
    //       this.cartTempCollection.push(_selectedItem)
    //     }
    //     else if (!selectedItem.option._selected) {
    //       _selectedCartItemText = this.cartHelper.getSelectedCartText(_selectedValue, _collection)
    //       if (this.cartTempCollection.length > 0) {
    //         _index = this.cartTempCollection.findIndex(element => {
    //           return ((element['value'] == _selectedValue) && (element['text'] == _selectedCartItemText))
    //         })
    //         if (_index > -1) {
    //           this.cartTempCollection.splice(_index, 1)
    //         }
    //       }
    //     }
    //   }
    // }
    // moveAllItems() {
    //   let _isRecordAvailable: boolean = false
    //   if (this.cartCollection && this.cartCollection.length > 0) {
    //     //If right hand cart is empty
    //     if (this.cartSelectedCollection.length == 0)
    //       this.cartSelectedCollection = this.cartCollection
    //     //If it contains records
    //     else if (this.cartSelectedCollection.length > 0) {
    //       this.cartCollection.forEach(element => {
    //         _isRecordAvailable = this.cartHelper.isRecordAvailable(element['value'], this.cartSelectedCollection)
    //         if (!_isRecordAvailable)
    //           this.cartSelectedCollection.push(element)
    //       })
    //     }
    //     if (this.leftSearchValue.trim() != '') {
    //       this._leftTempCollection = this.cartHelper.removeSelectedItems(this._leftTempCollection, this.cartCollection)
    //       this.cartCollection = this._leftTempCollection
    //     }
    //     else {
    //       this.cartCollection = []
    //       this._leftTempCollection = []
    //     }
    //     this._rightTempCollection = this.cartSelectedCollection
    //     this.leftSearchValue = ''
    //     this.handleSelectArrows()
    //   }
    // }
    // removeAllItems() {
    //   if (this.cartSelectedCollection && this.cartSelectedCollection.length > 0) {
    //     if (this.cartCollection.length == 0)
    //       this.cartCollection = this.cartSelectedCollection
    //     else if (this.cartCollection.length > 0) {
    //       this.cartSelectedCollection.forEach(element => {
    //         this.cartCollection.push(element)
    //       })
    //     }
    //     if (this.rightSearchValue.trim() != '') {
    //       this._rightTempCollection = this.cartHelper.removeSelectedItems(this._rightTempCollection, this.cartSelectedCollection)
    //       this.cartSelectedCollection = this._rightTempCollection
    //     }
    //     else {
    //       this.cartSelectedCollection = []
    //       this._rightTempCollection = []
    //     }
    //     this._leftTempCollection = this.cartCollection
    //     this.rightSearchValue = ''
    //     // this._rightTempCollection = this.cartSelectedCollection
    //     this.handleSelectArrows()
    //   }
    // }
    moveSelectedItems() {
        let _tmpSelectedCollection = [];
        // If leftTemp Colln is empty then set the value = cart collection
        if (this._leftTempCollection.length === 0) {
            this._leftTempCollection = this.cartCollection;
        }
        this.cartCollection.forEach(element => {
            if (element.selected) {
                element.selected = false;
                element.selectMode = '';
                _tmpSelectedCollection.push(element);
            }
        });
        this.cartMoveSelectedItems(_tmpSelectedCollection);
        this.cartTempCollection = [];
        this.leftSearchValue = '';
    }
    cartMoveSelectedItems(_tmpSelectedCollection) {
        let _isRecordAvailable = false;
        let _selIndex = -1;
        let _leftTempIndex = -1;
        let selectedValueCount = 0;
        selectedValueCount = _tmpSelectedCollection.length;
        if (_tmpSelectedCollection.length > 0) { // if (this.cartCollection.length > 0) {
            _tmpSelectedCollection.forEach(element => {
                element.selected = false;
                _isRecordAvailable =
                    this.cartHelper.isRecordAvailable(element['value'], element['text'], this._rightTempCollection);
                // If record not available to right cart then push to it.
                if (!_isRecordAvailable) {
                    this._rightTempCollection.push(element);
                }
                _selIndex = this.cartHelper.getMatchingIndex(this.cartCollection, element['value'], element['text']);
                _leftTempIndex = this.cartHelper.getMatchingIndex(this._leftTempCollection, element['value'], element['text']);
                if (_selIndex > -1 && _leftTempIndex > -1) {
                    if (this.leftSearchValue.trim() === '') {
                        this._leftTempCollection.splice(_leftTempIndex, 1);
                    }
                    else if (this.leftSearchValue.trim() !== '') {
                        this.cartCollection.splice(_selIndex, 1);
                        this._leftTempCollection.splice(_leftTempIndex, 1);
                    }
                }
            });
            this.cartSelectedCollection = this._rightTempCollection.slice(0, 100);
            this.cartCollection = this._leftTempCollection.slice(0, 100);
            this.totalSelectedItemCount = this._rightTempCollection.length;
            this.totalItemCount = this.totalItemCount - selectedValueCount;
            this.handleSelectArrows();
        }
    }
    moveAllItems() {
        /* This will move all the cart items from left to right based on below 2 scenarios:
           1. When user clicks move all button
           2. When user searches for a particular text and move all, only the searched collection will be moved to right.
           */
        let _isRecordAvailable = false;
        let _searchedCollection = [];
        if (this.cartCollection && this.cartCollection.length > 0) {
            // If right hand cart is empty
            if (this.cartSelectedCollection.length === 0) {
                if (this.leftSearchValue.trim() !== '') {
                    this._rightTempCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue, 0, 100, 'all');
                }
                else {
                    this._rightTempCollection = this._leftTempCollection;
                }
            }
            else if (this.cartSelectedCollection.length > 0) {
                if (this.leftSearchValue.trim() === '') {
                    this._leftTempCollection.forEach(element => {
                        element.selected = false;
                        _isRecordAvailable = this.cartHelper.isRecordAvailable(element['value'], element['text'], this._rightTempCollection);
                        if (!_isRecordAvailable) {
                            this._rightTempCollection.push(element);
                        }
                    });
                }
                else {
                    _searchedCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim(), 0, 100, 'all');
                    _searchedCollection.forEach(element => {
                        element.selected = false;
                        this._rightTempCollection.push(element);
                    });
                }
            }
            if (this.leftSearchValue.trim() !== '') {
                this._leftTempCollection = this.cartHelper.removeSelectedItems(this._leftTempCollection, this._rightTempCollection);
                this.cartCollection = this._leftTempCollection.slice(0, 100);
            }
            else {
                this.cartCollection = [];
                this._leftTempCollection = [];
            }
            this.leftSearchValue = '';
            this.cartSelectedCollection = this._rightTempCollection; // .slice(0, 100);
            this.totalSelectedItemCount = this._rightTempCollection.length;
            this.totalItemCount = 0;
            this.handleSelectArrows();
        }
    }
    removeSelectedItems() {
        let _selIndex = -1;
        let _rightTempIndex = -1;
        let _isRecordAvailable = false;
        let selectedCount = 0;
        // If leftTemp Colln is empty then set the value = cart collection
        if (this._rightTempCollection.length === 0) {
            this._rightTempCollection = this.cartSelectedCollection;
        }
        if (this.cartSelectedCollection.length > 0) {
            this.cartSelectedCollection.forEach(element => {
                if (element) {
                    // Moving only the selected items
                    if (element.selected === true) {
                        selectedCount++;
                        _isRecordAvailable = this.cartHelper.isRecordAvailable(element['value'], element['text'], this.cartCollection);
                        element.selected = false;
                        element.selectMode = '';
                        // If record is not available then move to left side cart
                        if (!_isRecordAvailable) {
                            this._leftTempCollection.push(element);
                        }
                        _selIndex = this.cartHelper.getMatchingIndex(this.cartSelectedCollection, element['value'], element['text']);
                        _rightTempIndex = this.cartHelper.getMatchingIndex(this._rightTempCollection, element['value'], element['text']);
                        if (_selIndex > -1 && _rightTempIndex > -1) {
                            this._rightTempCollection.splice(_rightTempIndex, 1);
                        }
                    }
                }
            });
            this.cartTempCollection = [];
            this.cartCollection = this._leftTempCollection.slice(0, 100);
            this.cartSelectedCollection = this._rightTempCollection.slice(0, 100);
            this.rightSearchValue = '';
            this.totalSelectedItemCount = this._rightTempCollection.length;
            this.totalItemCount = this.totalItemCount + selectedCount;
            this.handleSelectArrows();
        }
    }
    removeAllItems() {
        /* This will move all the cart items from left to right based on below 2 scenarios:
        1. When user clicks move all button
        2. When user searches for a particular text and move all, only the searched collection will be moved to right.
        */
        let _isRecordAvailable = false;
        let _tmpCollection = [];
        let selectedCount = 0;
        selectedCount = this._rightTempCollection.length;
        if (this.cartSelectedCollection && this.cartSelectedCollection.length > 0) {
            // If right hand cart is empty
            if (this.cartCollection.length === 0) {
                if (this.rightSearchValue.trim() !== '') {
                    this.cartCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue, 0, 100);
                    this._leftTempCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue, 0, 100, 'all');
                }
                else {
                    this.cartCollection = this._rightTempCollection.slice(0, 100);
                    this._leftTempCollection = this._rightTempCollection;
                }
            }
            else if (this.cartCollection.length > 0) {
                if (this.rightSearchValue.trim() === '') {
                    _tmpCollection = this._rightTempCollection;
                }
                else {
                    _tmpCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue, 0, 100, 'all');
                }
                _tmpCollection.forEach(element => {
                    element.selected = false;
                    _isRecordAvailable = this.cartHelper.isRecordAvailable(element['value'], element['text'], this._leftTempCollection);
                    if (!_isRecordAvailable) {
                        this._leftTempCollection.push(element);
                    }
                });
                this.cartCollection = this._leftTempCollection.slice(0, 100);
            }
            if (this.rightSearchValue.trim() !== '') {
                this._rightTempCollection = this.cartHelper.removeSelectedItems(this._rightTempCollection, this._leftTempCollection);
                this.cartSelectedCollection = this._rightTempCollection.slice(0, 100);
            }
            else {
                this.cartSelectedCollection = [];
                this._rightTempCollection = [];
            }
            this.rightSearchValue = '';
            this.totalSelectedItemCount = this._rightTempCollection.length;
            this.totalItemCount = this.totalItemCount + selectedCount;
            this.totalSelectedItemCount = 0;
            this.handleSelectArrows();
        }
    }
    // handleSelectArrows() {
    //   if (this.cartCollection.length > 0) {
    //     this._selectArrowModel.isLeftAllDisabled = false
    //     this._selectArrowModel.isLeftDisabled = false
    //   }
    //   else {
    //     this._selectArrowModel.isLeftAllDisabled = true
    //     this._selectArrowModel.isLeftDisabled = true
    //   }
    //   if (this.cartSelectedCollection.length > 0) {
    //     this._selectArrowModel.isRightAllDisabled = false
    //     this._selectArrowModel.isRightDisabled = false
    //   }
    //   else {
    //     this._selectArrowModel.isRightAllDisabled = true
    //     this._selectArrowModel.isRightDisabled = true
    //   }
    // }
    handleSelectArrows(_location) {
        if (_location) {
            if (_location === 'left') {
                if (this.cartTempCollection.length > 0) {
                    this._selectArrowModel.isLeftAllDisabled = true;
                    this._selectArrowModel.isLeftDisabled = false;
                }
                else {
                    this._selectArrowModel.isLeftAllDisabled = false;
                    this._selectArrowModel.isLeftDisabled = true;
                }
            }
            else if (_location === 'right') {
                if (this.cartTempCollection.length > 0) {
                    this._selectArrowModel.isRightAllDisabled = true;
                    this._selectArrowModel.isRightDisabled = false;
                }
                else {
                    this._selectArrowModel.isRightAllDisabled = false;
                    this._selectArrowModel.isRightDisabled = true;
                }
            }
        }
        else {
            if (this.cartCollection.length > 0) {
                this._selectArrowModel.isLeftAllDisabled = false;
                this._selectArrowModel.isLeftDisabled = true;
            }
            else {
                this._selectArrowModel.isLeftAllDisabled = true;
                this._selectArrowModel.isLeftDisabled = true;
            }
            if (this.cartSelectedCollection.length > 0) {
                this._selectArrowModel.isRightAllDisabled = false;
                this._selectArrowModel.isRightDisabled = true;
            }
            else {
                this._selectArrowModel.isRightAllDisabled = true;
                this._selectArrowModel.isRightDisabled = true;
            }
        }
    }
    emitSearchTextWithDebounce(context, func, delayPeriod) {
        let debounceTimer;
        return function () {
            const context1 = context;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer
                = setTimeout(() => func.apply(context1, args), delayPeriod);
        };
    }
    emitSearchText(event) {
        this.leftSearchValueChange.next(event);
    }
    filterExistingRecords() {
        if (this._leftTempCollection && this._leftTempCollection.length === 0) {
            this._leftTempCollection = this.cartCollection;
        }
        this.cartCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim());
    }
    searchLeftCart() {
        this.isNoRecordsInLeft = false;
        if (this.SearchLength.toString().trim() === '0') {
            if (this._leftTempCollection && this._leftTempCollection.length === 0) {
                this._leftTempCollection = this.cartCollection;
            }
            this.cartCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim());
            // setTimeout(() => {
            //   if (this.cartCollection.length === 0) {
            //     this.isNoRecordsInLeft = true;
            //   } else {
            //     this.isNoRecordsInLeft = false;
            //   }
            // }, 3000);
        }
        else {
            if (this.leftSearchValue.length >= this.SearchLength) {
                // if (this._leftTempCollection && this._leftTempCollection.length === 0)
                {
                    let _isDataSourceAvailable = false;
                    if (JSON.stringify(this.CartParameters) !== '{}') {
                        if (this.CartParameters['WebapiURL']) {
                            this.cartParams = this.CartParameters;
                            this.loadCartParams();
                        }
                        else if (this.CartParameters['dataSource']) {
                            _isDataSourceAvailable = true;
                            this.dataSource = this.CartParameters['dataSource'];
                            this.setCartCollection(null, this.CartParameters['settings']);
                            this.cartParams = this.CartParameters;
                            this.setDefaultCartItems();
                        }
                    }
                    this._leftTempCollection = this.cartCollection;
                }
                this.cartCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim());
                // setTimeout(() => {
                //   if (this.cartCollection.length === 0) {
                //     this.isNoRecordsInLeft = true;
                //   } else {
                //     this.isNoRecordsInLeft = false;
                //   }
                // }, 3000);
            }
        }
    }
    // searchLeftCart() {
    //   if (this._leftTempCollection && this._leftTempCollection.length === 0) {
    //     this._leftTempCollection = this.cartCollection;
    //   }
    //   this.cartCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim());
    //   if (this.cartCollection.length === 0) {
    //     this.isNoRecordsInLeft = true;
    //   } else {
    //     this.isNoRecordsInLeft = false;
    //   }
    // }
    searchRightCart() {
        if (this._rightTempCollection && this._rightTempCollection.length === 0) {
            this._rightTempCollection = this.cartSelectedCollection;
        }
        this.cartSelectedCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue.trim());
        if (this.cartSelectedCollection.length === 0) {
            this.isNoRecordsInRight = true;
        }
        else {
            this.isNoRecordsInRight = false;
        }
    }
    emitcloseevent(event) {
        this.OnCartClose.emit(event);
    }
    emitSelectedCartItems() {
        const itemCount = this.cartSelectedCollection.length;
        const isMinItemValid = (itemCount >= this.minimumSelectedItemCount) ? true : false;
        const isMaxItemValid = (this.maximumSelectedItemCount < 0) ? true : (itemCount <= this.maximumSelectedItemCount) ? true : false;
        let message = "";
        if (!isMinItemValid && !isMaxItemValid) {
            message = `Please select minimum ${this.minimumSelectedItemCount} and maximum ${this.maximumSelectedItemCount} item${this.maximumSelectedItemCount > 1 ? 's' : ''} in the cart`;
        }
        else if (!isMinItemValid) {
            message = "Please select atleast one item in the cart";
        }
        else if (!isMaxItemValid) {
            message = `Please select maximum ${this.maximumSelectedItemCount} item${this.maximumSelectedItemCount > 1 ? 's' : ''} in the cart`;
        }
        if (message) {
            let _dialogBoxHelper = new DialogBoxHelper();
            _dialogBoxHelper.showAlert(message, this.dialog);
        }
        else {
            const selectedCartItems = (this.cartSelectedCollection && this.cartSelectedCollection.length > 0) ? this.cartSelectedCollection : [];
            this.OnCartSubmit.emit(selectedCartItems);
            // this.dialogRef.close(selectedCartItems)
        }
    }
    scrollEvent() {
        // console.log('scrolling');
    }
    getCartItems(selectedItem, _location, _value, _action) {
        let _selectedItem = {};
        let _selectedCartItemText = '';
        let _collection = [];
        let _selectedValue = '';
        let _index = -1;
        let _isKeyEvent = false;
        let _selectedText = '';
        let _selectedCartItem = [];
        if (_action !== 'keyEvent') {
            if (!_value || _value === '') {
                _selectedValue = selectedItem.option._value;
            }
            else if (_value) {
                _selectedValue = _value;
            }
            if (_location === 'left') {
                _selectedCartItem = this.cartHelper.getFilteredCartItems(this.cartCollection, _selectedValue);
            }
            else if (_location === 'right') {
                _selectedCartItem = this.cartHelper.getFilteredCartItems(this.cartSelectedCollection, _selectedValue);
            }
        }
        else if (_action === 'keyEvent') {
            _value = selectedItem.target.id;
            this.handleShiftSelection(_value, selectedItem);
            _isKeyEvent = true;
        }
        if (!_isKeyEvent) {
            if (_location === 'left') {
                _collection = this.cartCollection;
                this._selectArrowModel.isLeftDisabled = false;
            }
            else if (_location === 'right') {
                _collection = this.cartSelectedCollection;
                this._selectArrowModel.isRightDisabled = false;
            }
            if (selectedItem.option._selected) {
                _selectedItem = _selectedCartItem[0];
                this.cartTempCollection.push(_selectedItem);
            }
            else if (!selectedItem.option._selected) {
                _selectedCartItemText = this.cartHelper.getSelectedCartText(_selectedValue, _collection);
                if (this.cartTempCollection.length > 0) {
                    _index = this.cartTempCollection.findIndex(element => {
                        if (element) {
                            return ((element['value'] === _selectedValue) && (element['text'] === _selectedCartItemText));
                        }
                    });
                    if (_index > -1) {
                        this.cartTempCollection.splice(_index, 1);
                    }
                }
            }
            if (_location === 'left') {
                if (this.cartSelectedCollection && this.cartSelectedCollection.length > 0) {
                    for (let i = 0; i < this.cartSelectedCollection.length; i++) {
                        this.cartSelectedCollection[i].selected = false;
                    }
                    this._selectArrowModel.isLeftDisabled = false;
                    this._selectArrowModel.isRightDisabled = true;
                }
                _index = this.cartHelper.getCartIndex(_selectedValue, this.cartCollection);
                // Move to right on dbl click
                if (_action === 'dblclick') {
                    this.cartCollection.filter(element => {
                        element.selected = false;
                    });
                    this.cartCollection[_index].selected = true;
                }
                else {
                    this.cartCollection[_index].selected = !this.cartCollection[_index].selected;
                }
            }
            else if (_location === 'right') {
                if (this.cartCollection && this.cartCollection.length > 0) {
                    for (let i = 0; i < this.cartCollection.length; i++) {
                        this.cartCollection[i].selected = false;
                    }
                    this._selectArrowModel.isLeftDisabled = true;
                    this._selectArrowModel.isRightDisabled = false;
                }
                _index = this.cartHelper.getCartIndex(_selectedValue, this.cartSelectedCollection);
                // Move to left on dbl click
                if (_action === 'dblclick') {
                    this.cartSelectedCollection.filter(element => {
                        element.selected = false;
                    });
                    this.cartSelectedCollection[_index].selected = true;
                }
                else {
                    this.cartSelectedCollection[_index].selected = !this.cartSelectedCollection[_index].selected;
                }
            }
        }
        this.handleSelectArrows(_location);
    }
    handleShiftSelection(_keyEvent, _location) {
        let _index = 0;
        let _value = '';
        let _collection = [];
        _keyEvent.stopPropagation();
        _keyEvent.preventDefault();
        if (_location === 'left') {
            _collection = this.cartCollection;
        }
        else {
            _collection = this.cartSelectedCollection;
        }
        if (_keyEvent.key === 'ArrowUp' && _keyEvent.shiftKey) {
            _value = document.activeElement.id;
            _index = this.cartHelper.getCartIndex(_value, _collection);
            if (_index > 0) {
                _collection[_index - 1].selected = !_collection[_index - 1].selected;
                _collection[_index - 1].selectMode = 'key';
                document.activeElement.id = _collection[_index - 1].value;
            }
        }
        else if (_keyEvent.key === 'ArrowDown' && _keyEvent.shiftKey) {
            _value = document.activeElement.id;
            _index = this.cartHelper.getCartIndex(_value, _collection);
            if (_index < _collection.length) {
                if (_collection[_index].selectMode === 'key' && _collection[_index].selected) {
                    _collection[_index].selected = false;
                }
                else {
                    _collection[_index].selected = true;
                    _collection[_index].selectMode = 'key';
                }
                if (_index !== _collection.length - 1) {
                    document.activeElement.id = _collection[_index + 1].value;
                }
            }
        }
        // Add to cart Temp collection
        _collection.filter(element => {
            if (element) {
                if (element.selected) {
                    this.cartTempCollection.push(element);
                }
            }
        });
        this.handleSelectArrows(_location);
    }
    scrollLeftCart() {
        let _minLimit = 0;
        let _maxLimit = 0;
        if (this.cartCollection.length < this._leftTempCollection.length) {
            _minLimit = this.cartCollection.length;
            if ((_minLimit + 100) < this._leftTempCollection.length) {
                _maxLimit = _minLimit + 100;
            }
            else {
                _maxLimit = _minLimit + this._leftTempCollection.length;
            }
            this.cartCollection = [...this.cartCollection,
                ...this.loadCart(this._leftTempCollection, _minLimit, _maxLimit, this.leftSearchValue)];
        }
        // this.handleSelectArrows()
    }
    scrollRightCart() {
        let _minLimit = 0;
        let _maxLimit = 0;
        if (this.cartSelectedCollection.length < this._rightTempCollection.length) {
            _minLimit = this.cartSelectedCollection.length;
            if ((_minLimit + 100) < this._rightTempCollection.length) {
                _maxLimit = _minLimit + 100;
            }
            else {
                _maxLimit = _minLimit + this._rightTempCollection.length;
            }
            this.cartSelectedCollection = [...this.cartSelectedCollection,
                ...this.loadCart(this._rightTempCollection, _minLimit, _maxLimit, this.rightSearchValue)];
        }
    }
    moveItems(_value, _originLocation) {
        let _selectedItem = {
            'option': {
                '_selected': true, '_value': _value
            }
        };
        const _action = 'dblclick';
        // Emptying the cart collection so that only double clicked item gets moved
        this.cartTempCollection = [];
        this.getCartItems(_selectedItem, _originLocation, _value, _action);
        if (_originLocation === 'left') {
            this.moveSelectedItems();
        }
        else if (_originLocation === 'right') {
            this.removeSelectedItems();
        }
        this.handleSelectArrows();
    }
}
EIPGeneralCartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartComponent, deps: [{ token: 'environment' }, { token: EIPGeneralCartService }, { token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Component });
EIPGeneralCartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EIPGeneralCartComponent, selector: "EIPGeneralCart", inputs: { generalcartParams: "generalcartParams", CartParameters: "CartParameters", postButtonText: "postButtonText", SearchLength: "SearchLength", excelUploadAPIParams: "excelUploadAPIParams", excelUploadWithAPICall: "excelUploadWithAPICall", leftSearchValue: "leftSearchValue" }, outputs: { OnCartClose: "OnCartClose", OnCartSubmit: "OnCartSubmit", leftSearchValueChange: "leftSearchValueChange" }, viewQueries: [{ propertyName: "uploadFile", first: true, predicate: ["uploadFile"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"Showloader\" class=\"k-i-loading\"></div>\r\n<div class=\"job-cart-container\">\r\n  <div class=\"row\">\r\n    <div class=\"job-list-right job-list-left col-md-6\">\r\n      <div class=\"job-cart\">\r\n        <div class=\"row mb-3\">\r\n          <div class=\"col-md-12\">\r\n            <h5><i *ngIf=\"isCloseCirecleRequired === 'Y'\" class=\"fa fa-arrow-circle-left\"\r\n                (click)='emitcloseevent($event)'></i> {{cartText}}</h5>\r\n          </div>\r\n          <div *ngIf=\"excelProperty.length > 0\" class=\"upload-btn-wrapper\">\r\n            <button class=\"btn\">\r\n              <i class=\"fa fa-file-excel-upload-o\"></i>\r\n            </button>\r\n            <input\r\n            accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv\"\r\n            #uploadFile type=\"file\" name=\"myfile\" (change)=\"onFileChange($event)\"/>\r\n          </div>\r\n\r\n        </div>\r\n\r\n\r\n        <div class=\"job-cart-box\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-10\">\r\n              <mat-form-field class=\"example-full-width job-cart-search\">\r\n                <input *ngIf=\"SearchLength > 0\" matInput [placeholder]=\"placeHolderContent\" aria-label=\"Job Cart\"\r\n                  #strSearchTextInput1 [(ngModel)]='leftSearchValue' autocomplete=\"off\"\r\n                  (ngModelChange)=\"emitSearchText($event); filterExistingRecords();\" (blur)=\"searchLeftCart()\">\r\n                <input *ngIf=\"SearchLength == 0\" matInput [placeholder]=\"placeHolderContent\" aria-label=\"Job Cart\"\r\n                  #strSearchTextInput [(ngModel)]='leftSearchValue' autocomplete=\"off\"\r\n                  (ngModelChange)='emitSearchText($event); searchLeftCart(); '>\r\n\r\n\r\n                <!-- <span matSuffix><i class=\"fa fa-search\"></i></span>\r\n                (ngModelChange)='searchLeftCart()'-->\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-2 p-0 align-self-center\">\r\n              <div class=\"btn-group\">\r\n                <button class=\"btn btn-default job-selector\" (click)='moveSelectedItems()' title='Select'\r\n                  [disabled]='_selectArrowModel.isLeftDisabled'>\r\n                  <i class=\"fa fa-angle-right font-weight-bold\"></i></button>\r\n                <button class=\"btn btn-default job-selector\" title=\"Select all\" (click)='moveAllItems()'\r\n                  [disabled]='_selectArrowModel.isLeftAllDisabled'>\r\n                  <i class=\"fa fa-angle-double-right font-weight-bold\"></i></button>\r\n\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <mat-selection-list (selectionChange)='getCartItems($event, \"left\")' dense (scroll)='scrollLeftCart()'>\r\n            <mat-list-option class=\"material-list-options\" *ngFor=\"let items of cartCollection\" [value]='items.value'\r\n              [id]='items.value' (dblclick)='moveItems(items.value, \"left\")'\r\n              (keydown)='handleShiftSelection($event, \"left\");' [title]='items.text' [selected]='items.selected'>\r\n              {{items.text}}\r\n            </mat-list-option>\r\n\r\n\r\n            <mat-list-option\u00A0*ngIf='isNoRecordsInLeft'>\r\n              No records found\r\n            </mat-list-option>\r\n\r\n          </mat-selection-list>\r\n\r\n        </div>\r\n        <div class=\"job-post-button\">\r\n\r\n          <div *ngIf=\"totalCountDisplay === 'Y'\">\r\n            <div style=\"margin-left: 10px;\">Total Item : {{totalItemCount}}</div>\r\n          </div>\r\n          <button class=\"btn btn-primary float-right invisible\">{{postButtonText}}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"job-list-right col-md-6\">\r\n      <div class=\"job-cart\">\r\n\r\n        <div class=\"row mb-3\">\r\n          <div class=\"col-md-12\">\r\n            <h5> {{cartRightText}} </h5>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"job-cart-box job-cart-box1\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-2 align-self-center\">\r\n              <div class=\"btn-group\">\r\n                <button class=\"btn btn-default job-selector\" (click)='removeAllItems()' title='Unselect all'\r\n                  [disabled]='_selectArrowModel.isRightAllDisabled'>\r\n                  <i class=\"fa fa-angle-double-left font-weight-bold\"></i>\r\n                </button>\r\n                <button class=\"btn btn-default job-selector \" title=\"select all\" (click)='removeSelectedItems()'\r\n                  title='Unselect' [disabled]='_selectArrowModel.isRightDisabled'><i\r\n                    class=\"fa fa-angle-left font-weight-bold\"></i></button>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-10\">\r\n              <mat-form-field class=\"example-full-width job-cart-search\">\r\n                <input matInput placeholder=\"Search...\" aria-label=\"Job Cart\" autocomplete=\"off\"\r\n                  [(ngModel)]='rightSearchValue' (ngModelChange)='searchRightCart()'>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <!-- <mat-list role=\"list\">\r\n              <mat-list-item role=\"listitem\" class=\"job-list\">Item 1</mat-list-item>\r\n              <mat-list-item role=\"listitem\" class=\"job-list\">Item 2</mat-list-item>\r\n              <mat-list-item role=\"listitem\" class=\"job-list\">Item 3</mat-list-item>\r\n            </mat-list> -->\r\n\r\n\r\n          <mat-selection-list (selectionChange)='getCartItems($event, \"right\")' dense (scroll)='scrollRightCart()'>\r\n            <mat-list-option class=\"material-list-options\" *ngFor=\"let items of cartSelectedCollection\"\r\n              (dblclick)='moveItems(items.value, \"right\")' [id]='items.value'\r\n              (keydown)='handleShiftSelection($event, \"right\");' [value]='items.value' [title]=\"items.text\"\r\n              [selected]='items.selected'>\r\n              {{items.text}}\r\n            </mat-list-option>\r\n\r\n\r\n            <mat-list-option\u00A0*ngIf='isNoRecordsInRight'>\r\n              No records found\r\n            </mat-list-option>\r\n          </mat-selection-list>\r\n\r\n        </div>\r\n        <div class=\"job-post-button\">\r\n\r\n          <div class=\"row mb-0\" *ngIf=\"totalCountDisplay === 'Y'\">\r\n            <div style=\"margin-left: 20px;\">Total Selected Item : {{totalSelectedItemCount}}</div>\r\n          </div>\r\n          <button class=\"btn btn-primary float-right\" (click)='emitSelectedCartItems()'>Post</button>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["::ng-deep .mat-pseudo-checkbox{display:none!important}.job-auto-select input{border:none;border-bottom:1px solid #333}.k-i-loading{position:absolute;top:0px;left:0;right:0;bottom:0;font-size:64px;background-color:#ffffff4d;color:#ff6757;z-index:999}.upload-btn-wrapper{position:absolute;overflow:hidden;display:inline-block;right:20px}.upload-btn-wrapper .btn{font-size:20px;font-weight:700;padding:0}.upload-btn-wrapper input[type=file]{font-size:100px;position:absolute;left:0;top:0;opacity:0}\n"], components: [{ type: i3.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i4.MatSelectionList, selector: "mat-selection-list", inputs: ["disableRipple", "tabIndex", "color", "compareWith", "disabled", "multiple"], outputs: ["selectionChange"], exportAs: ["matSelectionList"] }, { type: i4.MatListOption, selector: "mat-list-option", inputs: ["disableRipple", "checkboxPosition", "color", "value", "disabled", "selected"], outputs: ["selectedChange"], exportAs: ["matListOption"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'EIPGeneralCart', template: "<div *ngIf=\"Showloader\" class=\"k-i-loading\"></div>\r\n<div class=\"job-cart-container\">\r\n  <div class=\"row\">\r\n    <div class=\"job-list-right job-list-left col-md-6\">\r\n      <div class=\"job-cart\">\r\n        <div class=\"row mb-3\">\r\n          <div class=\"col-md-12\">\r\n            <h5><i *ngIf=\"isCloseCirecleRequired === 'Y'\" class=\"fa fa-arrow-circle-left\"\r\n                (click)='emitcloseevent($event)'></i> {{cartText}}</h5>\r\n          </div>\r\n          <div *ngIf=\"excelProperty.length > 0\" class=\"upload-btn-wrapper\">\r\n            <button class=\"btn\">\r\n              <i class=\"fa fa-file-excel-upload-o\"></i>\r\n            </button>\r\n            <input\r\n            accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv\"\r\n            #uploadFile type=\"file\" name=\"myfile\" (change)=\"onFileChange($event)\"/>\r\n          </div>\r\n\r\n        </div>\r\n\r\n\r\n        <div class=\"job-cart-box\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-10\">\r\n              <mat-form-field class=\"example-full-width job-cart-search\">\r\n                <input *ngIf=\"SearchLength > 0\" matInput [placeholder]=\"placeHolderContent\" aria-label=\"Job Cart\"\r\n                  #strSearchTextInput1 [(ngModel)]='leftSearchValue' autocomplete=\"off\"\r\n                  (ngModelChange)=\"emitSearchText($event); filterExistingRecords();\" (blur)=\"searchLeftCart()\">\r\n                <input *ngIf=\"SearchLength == 0\" matInput [placeholder]=\"placeHolderContent\" aria-label=\"Job Cart\"\r\n                  #strSearchTextInput [(ngModel)]='leftSearchValue' autocomplete=\"off\"\r\n                  (ngModelChange)='emitSearchText($event); searchLeftCart(); '>\r\n\r\n\r\n                <!-- <span matSuffix><i class=\"fa fa-search\"></i></span>\r\n                (ngModelChange)='searchLeftCart()'-->\r\n              </mat-form-field>\r\n            </div>\r\n            <div class=\"col-md-2 p-0 align-self-center\">\r\n              <div class=\"btn-group\">\r\n                <button class=\"btn btn-default job-selector\" (click)='moveSelectedItems()' title='Select'\r\n                  [disabled]='_selectArrowModel.isLeftDisabled'>\r\n                  <i class=\"fa fa-angle-right font-weight-bold\"></i></button>\r\n                <button class=\"btn btn-default job-selector\" title=\"Select all\" (click)='moveAllItems()'\r\n                  [disabled]='_selectArrowModel.isLeftAllDisabled'>\r\n                  <i class=\"fa fa-angle-double-right font-weight-bold\"></i></button>\r\n\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <mat-selection-list (selectionChange)='getCartItems($event, \"left\")' dense (scroll)='scrollLeftCart()'>\r\n            <mat-list-option class=\"material-list-options\" *ngFor=\"let items of cartCollection\" [value]='items.value'\r\n              [id]='items.value' (dblclick)='moveItems(items.value, \"left\")'\r\n              (keydown)='handleShiftSelection($event, \"left\");' [title]='items.text' [selected]='items.selected'>\r\n              {{items.text}}\r\n            </mat-list-option>\r\n\r\n\r\n            <mat-list-option\u00A0*ngIf='isNoRecordsInLeft'>\r\n              No records found\r\n            </mat-list-option>\r\n\r\n          </mat-selection-list>\r\n\r\n        </div>\r\n        <div class=\"job-post-button\">\r\n\r\n          <div *ngIf=\"totalCountDisplay === 'Y'\">\r\n            <div style=\"margin-left: 10px;\">Total Item : {{totalItemCount}}</div>\r\n          </div>\r\n          <button class=\"btn btn-primary float-right invisible\">{{postButtonText}}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"job-list-right col-md-6\">\r\n      <div class=\"job-cart\">\r\n\r\n        <div class=\"row mb-3\">\r\n          <div class=\"col-md-12\">\r\n            <h5> {{cartRightText}} </h5>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"job-cart-box job-cart-box1\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-2 align-self-center\">\r\n              <div class=\"btn-group\">\r\n                <button class=\"btn btn-default job-selector\" (click)='removeAllItems()' title='Unselect all'\r\n                  [disabled]='_selectArrowModel.isRightAllDisabled'>\r\n                  <i class=\"fa fa-angle-double-left font-weight-bold\"></i>\r\n                </button>\r\n                <button class=\"btn btn-default job-selector \" title=\"select all\" (click)='removeSelectedItems()'\r\n                  title='Unselect' [disabled]='_selectArrowModel.isRightDisabled'><i\r\n                    class=\"fa fa-angle-left font-weight-bold\"></i></button>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-10\">\r\n              <mat-form-field class=\"example-full-width job-cart-search\">\r\n                <input matInput placeholder=\"Search...\" aria-label=\"Job Cart\" autocomplete=\"off\"\r\n                  [(ngModel)]='rightSearchValue' (ngModelChange)='searchRightCart()'>\r\n              </mat-form-field>\r\n            </div>\r\n          </div>\r\n          <!-- <mat-list role=\"list\">\r\n              <mat-list-item role=\"listitem\" class=\"job-list\">Item 1</mat-list-item>\r\n              <mat-list-item role=\"listitem\" class=\"job-list\">Item 2</mat-list-item>\r\n              <mat-list-item role=\"listitem\" class=\"job-list\">Item 3</mat-list-item>\r\n            </mat-list> -->\r\n\r\n\r\n          <mat-selection-list (selectionChange)='getCartItems($event, \"right\")' dense (scroll)='scrollRightCart()'>\r\n            <mat-list-option class=\"material-list-options\" *ngFor=\"let items of cartSelectedCollection\"\r\n              (dblclick)='moveItems(items.value, \"right\")' [id]='items.value'\r\n              (keydown)='handleShiftSelection($event, \"right\");' [value]='items.value' [title]=\"items.text\"\r\n              [selected]='items.selected'>\r\n              {{items.text}}\r\n            </mat-list-option>\r\n\r\n\r\n            <mat-list-option\u00A0*ngIf='isNoRecordsInRight'>\r\n              No records found\r\n            </mat-list-option>\r\n          </mat-selection-list>\r\n\r\n        </div>\r\n        <div class=\"job-post-button\">\r\n\r\n          <div class=\"row mb-0\" *ngIf=\"totalCountDisplay === 'Y'\">\r\n            <div style=\"margin-left: 20px;\">Total Selected Item : {{totalSelectedItemCount}}</div>\r\n          </div>\r\n          <button class=\"btn btn-primary float-right\" (click)='emitSelectedCartItems()'>Post</button>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["::ng-deep .mat-pseudo-checkbox{display:none!important}.job-auto-select input{border:none;border-bottom:1px solid #333}.k-i-loading{position:absolute;top:0px;left:0;right:0;bottom:0;font-size:64px;background-color:#ffffff4d;color:#ff6757;z-index:999}.upload-btn-wrapper{position:absolute;overflow:hidden;display:inline-block;right:20px}.upload-btn-wrapper .btn{font-size:20px;font-weight:700;padding:0}.upload-btn-wrapper input[type=file]{font-size:100px;position:absolute;left:0;top:0;opacity:0}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['environment']
                    }] }, { type: EIPGeneralCartService }, { type: i1$1.MatDialog }];
    }, propDecorators: { generalcartParams: [{
                type: Input
            }], CartParameters: [{
                type: Input
            }], postButtonText: [{
                type: Input
            }], SearchLength: [{
                type: Input
            }], excelUploadAPIParams: [{
                type: Input
            }], excelUploadWithAPICall: [{
                type: Input
            }], OnCartClose: [{
                type: Output
            }], OnCartSubmit: [{
                type: Output
            }], leftSearchValue: [{
                type: Input
            }], leftSearchValueChange: [{
                type: Output
            }], uploadFile: [{
                type: ViewChild,
                args: ['uploadFile', { static: false }]
            }] } });

// import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
class EIPGeneralCartModule {
}
EIPGeneralCartModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPGeneralCartModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartModule, declarations: [EIPGeneralCartComponent, MessageboxComponent], imports: [MatListModule, EIPAutoCompleteModule, CommonModule, MatInputModule,
        FormsModule, MatAutocompleteModule, MatButtonModule, MatFormFieldModule,
        MatRippleModule, MatCheckboxModule], exports: [EIPGeneralCartComponent] });
EIPGeneralCartModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartModule, imports: [[
            MatListModule, EIPAutoCompleteModule, CommonModule, MatInputModule,
            FormsModule, MatAutocompleteModule, MatButtonModule, MatFormFieldModule,
            MatRippleModule, MatCheckboxModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPGeneralCartModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EIPGeneralCartComponent, MessageboxComponent],
                    imports: [
                        MatListModule, EIPAutoCompleteModule, CommonModule, MatInputModule,
                        FormsModule, MatAutocompleteModule, MatButtonModule, MatFormFieldModule,
                        MatRippleModule, MatCheckboxModule
                    ],
                    exports: [EIPGeneralCartComponent],
                    entryComponents: [MessageboxComponent],
                    //   providers: [
                    //      {provide: MatDialogRef, useValue: {}},
                    //      {provide: MAT_DIALOG_DATA, useValue: {}},
                    //      {provide: MatDialog, useValue: {}},
                    //  ]
                }]
        }] });

/*
 * Public API Surface of eipgeneral-cart
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EIPGeneralCartComponent, EIPGeneralCartModule, EIPGeneralCartService };
